import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";

export function useListarSexos() {
  const fetchData = async () => {
    const LISTAR_SEXOS = `dadoscomum/sexos`;
    const response = await instance.get(LISTAR_SEXOS);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    refetchOnWindowFocus: false,
    queryKey: ["listar_sexos"],
    refetchOnMount: true,
  });
  return query;
}
